import { render, staticRenderFns } from "./PublicAppointmentBooking.vue?vue&type=template&id=46446868&scoped=true"
import script from "./PublicAppointmentBooking.vue?vue&type=script&lang=js"
export * from "./PublicAppointmentBooking.vue?vue&type=script&lang=js"
import style0 from "./PublicAppointmentBooking.vue?vue&type=style&index=0&id=46446868&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46446868",
  null
  
)

export default component.exports